import { render, staticRenderFns } from "./GoodsCategoryModal.vue?vue&type=template&id=1e82fbf8&scoped=true"
import script from "./GoodsCategoryModal.vue?vue&type=script&lang=ts"
export * from "./GoodsCategoryModal.vue?vue&type=script&lang=ts"
import style0 from "./GoodsCategoryModal.vue?vue&type=style&index=0&id=1e82fbf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e82fbf8",
  null
  
)

export default component.exports